module.exports = __webpack_public_path__ + "img/cp6-4.e04cbea9.jpg";